export default __webpack_public_path__ + "static/media/instagram.73eb3edc.svg";